import { observer } from 'mobx-react-lite'
import { useServiceStore } from '../../ServiceStore'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'

export default observer(function ServiceActionSave() {
   const serviceStore = useServiceStore()

   return <>
      <ButtonWithProgress variant="contained" loading={serviceStore.serviceSaveLoader.isLoading} onClick={serviceStore.saveService}>Save</ButtonWithProgress>
   </>
})
